// extracted by mini-css-extract-plugin
export default {"FiltersWrapper":"photo_filters_FiltersWrapper__n2l2m","FiltersContainer":"photo_filters_FiltersContainer__fxoBR"};